import { render, staticRenderFns } from "./publicizeNewsList.vue?vue&type=template&id=48228d3a&scoped=true"
import script from "./publicizeNewsList.vue?vue&type=script&lang=js"
export * from "./publicizeNewsList.vue?vue&type=script&lang=js"
import style0 from "./publicizeNewsList.vue?vue&type=style&index=0&id=48228d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48228d3a",
  null
  
)

export default component.exports